<template>
  <el-drawer
    :visible.sync="drawer"
    direction="rtl"
    append-to-body
    :with-header="false"
    :before-close="handleClose"
    size="620px"
  >
    <div class="drawer-wrap">
      <common-header :node-data="form" @close="handleClose" />
      <!-- 节点循环 -->
      <main>
        <ul class="branch-list-wrap">
          <!-- 循环条件组 审批人和条件分支展示 -->
          <li v-for="(group, index) in form.form" :key="index + 'group'">
            <!-- 或 -->
            <div v-if="index > 0" class="group-operator">{{ $t('work_rule_32') }}</div>
            <div class="branch-detail">
              <h1>
                <span>{{ $t('work_rule_24', { x: index + 1 }) }}</span>
                <el-button
                  v-if="form.form.length > 1"
                  type="text"
                  class="delete-flow"
                  @click="handlerDelConditonGroup(index)"
                >
                  <i class="el-icon-delete" />
                </el-button>
              </h1>
              <div v-for="(branch, i) in group" :key="i + 'branch'">
                <div v-if="group.length > 1" class="operator-text">
                  <div>{{ i === 0 ? $t('work_rule_30') : $t('work_rule_31') }}</div>
                </div>
                <div class="son-branch-list">
                  <el-form ref="branchs" inline :rules="condiyionRules" :model="branch">
                    <!-- 条件类型 -->
                    <el-form-item prop="condition">
                      <el-select
                        v-model="branch.condition"
                        :placeholder="$t('work_rule_25')"
                        value-key="condition_type"
                        @change="handlerConChange(branch)"
                      >
                        <el-option
                          v-for="item in enums.condition"
                          :key="item.condition_type"
                          :label="item.name"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>
                    <!-- 逻辑运算符 -->
                    <el-form-item prop="operator" v-if="branch.condition.key">
                      <el-select
                        class="operational-logic"
                        value-key="operator_type"
                        :placeholder="$t('work_rule_27')"
                        v-model="branch.operator"
                      >
                        <el-option
                          v-for="item in enums.operator[branch.condition.key]"
                          :key="item.operator_type"
                          :label="item.name"
                          :value="item"
                        />
                      </el-select>
                    </el-form-item>
                    <!-- 值选项 -->
                    <el-form-item prop="value" v-if="branch.condition">
                      <template v-if="enums.option[branch.condition.key] && enums.option[branch.condition.key].length">
                        <!-- :props="{ checkStrictly: true, emitPath: false }" -->
                        <!-- @change="v => handleSelectDepart(branch, v)" -->
                        <depart
                          v-if="branch.condition.key === 'department_id'"
                          :options="enums.option[branch.condition.key]"
                          v-model="branch.value"
                        ></depart>
                        <el-select
                          v-else
                          class="operational-logic"
                          value-key="value"
                          v-model="branch.value"
                          :placeholder="$t('please_select_message')"
                        >
                          <el-option
                            v-for="item in enums.option[branch.condition.key]"
                            :key="item.value"
                            :label="item.name"
                            :value="item"
                          />
                        </el-select>
                      </template>
                      <!-- 输入框时展示 -->
                      <template v-else>
                        <!-- 请假时长，加班时长，出差时长 正整数小数位最多三次-->
                        <el-input
                          v-show="['1', '4', '7'].includes(branch.condition.condition_type)"
                          class="operational-logic"
                          v-model="branch.value.value"
                          v-enterNumberPoint="3"
                          v-enterNumberMax="999"
                          v-enterNumberMin="0"
                        ></el-input>
                        <!-- 金额 正负整数-->
                        <el-input
                          v-show="['10'].includes(branch.condition.condition_type)"
                          class="operational-logic"
                          v-model.number="branch.value.value"
                        >
                        </el-input>
                        <el-input
                          v-show="!['1', '4', '7', '10'].includes(branch.condition.condition_type)"
                          class="operational-logic"
                          v-model="branch.value.value"
                        ></el-input>
                      </template>
                    </el-form-item>

                    <!-- 有单位的情况下展示 -->
                    <el-form-item v-if="branch.condition.unit">
                      <el-input class="operational-logic" v-model="branch.condition.unit" disabled></el-input>
                    </el-form-item>
                    <!-- 删除条件 -->
                    <el-button
                      v-if="group.length > 1"
                      type="text"
                      class="delete-flow delete-branch"
                      @click="handleDelCondition(group, i)"
                    >
                      <i class="el-icon-delete" />
                    </el-button>
                  </el-form>
                </div>
              </div>
              <!-- 添加条件 -->
              <el-button type="text" icon="el-icon-plus" class="add-condition" @click="handlerAddCondition(group)">{{
                $t('work_rule_27')
              }}</el-button>
            </div>
          </li>
        </ul>
        <!-- 增加条件组 -->
        <el-button type="text" icon="el-icon-plus" class="add-condition-list" @click="handlerAddContitionGroup()">{{
          $t('work_rule_28')
        }}</el-button>
      </main>
      <footer>
        <el-button plain round size="small" @click="handleClose"> {{ $t('cancel_btn') }}</el-button>
        <el-button type="primary" round size="small" @click="handlerSave">{{ $t('save_btn') }}</el-button>
      </footer>
    </div>
  </el-drawer>
</template>

<script>
import { branchFormItem } from '../examples'
import { condiyionRules } from '../rules'
import CommonHeader from '../components/common-header'
import { getConditionList } from 'api/flow'
import depart from '../components/depart'
import './directive'
export default {
  components: { CommonHeader, depart },
  props: {
    // 组件是否展示
    drawer: {
      default: false,
      type: Boolean
    },
    // 当前节点数据
    nodeData: {
      default: () => ({}),
      type: Object
    },
    baseInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {},
      condiyionRules, // 表单校验规则
      enums: {
        condition: [],
        operator: [],
        option: []
      }
    }
  },
  created() {
    // 数据拷贝
    this.form = {
      ...this.form,
      ...JSON.parse(JSON.stringify(this.nodeData))
    }
    this.getConditionList()
  },
  methods: {
    hChange(v) {
      console.log(v)
    },
    // 获取全部条件
    getConditionList() {
      getConditionList({ audit_type: this.baseInfo.audit_type }).then(res => {
        if (res && res.code === 1) {
          this.enums = res.data
        }
      })
    },
    // 节点条件变化则清空运算符
    // @parms { Object } item 当前条件
    handlerConChange(item) {
      item.operator = ''
      item.value = { value: '' }
    },
    // 组件关闭操作
    handleClose() {
      this.$emit('update:drawer', false)
    },
    // 添加条件
    handlerAddCondition(traget) {
      traget.push(branchFormItem())
    },
    // 添加条件组
    handlerAddContitionGroup() {
      this.form.form.push([branchFormItem()])
    },
    /**
     *  @description 删除条件组
     *  @param { Array } conditions 要删除子项的数组
     *  @param { number } index 要删除对象的下标
     */
    handleDelCondition(group, i) {
      group.splice(i, 1)
    },
    // 删除条件组 index下标
    handlerDelConditonGroup(index) {
      this.form.form.splice(index, 1)
    },
    /**
     *  @description 表单校验
     *  @returns { Boolean } 校验结果
     */
    branchsValidate() {
      return this.$refs.branchs.every(item => {
        let result = true
        item.validate(valid => {
          if (!valid) result = false
        })
        return result
      })
    },
    // 保存
    handlerSave() {
      // 自组件校验
      const state = this.branchsValidate()
      // 所有表单校验通过状态
      if (state) {
        const result = {
          ...this.nodeData,
          ...this.form
        }
        this.$emit('change', result)
        this.handleClose()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './drawer.scss';
</style>
